import { StringUtils } from "neo-common";

/**
 * @class Attributes
 */
export class Attributes {
    /**
     * @method assignIntAttribute
     * @param {Element} node
     * @param {string} attribute - XML node attribute, constant from ImageElementAttributes class
     * @param {number} defaultValue - value that is set if falsy value is read from node
     * @param radix
     * @return {number} parsed attribute value
     */
    static assignIntAttribute(node: Element, attribute: string, defaultValue: number, radix?: number): number {
        if (!node.hasAttribute(attribute)) {
            return defaultValue;
        }

        return parseInt(node.getAttribute(attribute), radix);
    }

    /**
     * @method assignFloatAttribute
     * @param {Element} node
     * @param {string} attribute - XML node attribute, constant from ImageElementAttributes class
     * @param {number} defaultValue - value that is set if falsy value is read from node
     * @return {number} parsed attribute value
     */
    static assignFloatAttribute(node: Element, attribute: string, defaultValue: number): number {
        if (!node.hasAttribute(attribute)) {
            return defaultValue;
        }

        return parseFloat(node.getAttribute(attribute));
    }

    /**
     * @method assignBooleanAttribute
     * @param {Element} node
     * @param {string} attribute - XML node attribute, constant from ImageElementAttributes class
     * @param {number} defaultValue - value that is set if falsy value is read from node
     * @return {boolean} parsed attribute value
     */
    static assignBooleanAttribute(node: Element, attribute: string, defaultValue: boolean): boolean {
        if (!node.hasAttribute(attribute)) {
            return defaultValue;
        }

        return StringUtils.parseBoolean(node.getAttribute(attribute));
    }

    /**
     * @method assignBooleanAttribute
     * @param {Element} node
     * @param {string} attribute - XML node attribute, constant from ImageElementAttributes class
     * @param {number} defaultValue - value that is set if falsy value is read from node
     * @return {boolean} parsed attribute value
     */
    static assignStringAttribute(node: Element, attribute: string, defaultValue: any): any {
        if (!node.hasAttribute(attribute)) {
            return defaultValue;
        }

        return node.getAttribute(attribute);
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Utils/Attributes.ts
 **/